import { useMutation } from "@tanstack/react-query";
import submitCustomFieldValue from "../../controllers/appointments/submit-custom-field";

const usePushAptFieldToApt = () => {
  return useMutation(submitCustomFieldValue, {});
};

export default usePushAptFieldToApt;
